/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Composite } from '../models/Composite';
import type { CompositeComment } from '../models/CompositeComment';
import type { CompositeDataCut } from '../models/CompositeDataCut';
import type { CompositeDataCutAdjustmentDetails } from '../models/CompositeDataCutAdjustmentDetails';
import type { CompositeHistory } from '../models/CompositeHistory';
import type { CompositePolicyEditor } from '../models/CompositePolicyEditor';
import type { CompositePolicySource } from '../models/CompositePolicySource';
import type { DataCutDisplayMode } from '../models/DataCutDisplayMode';
import type { EmployeeData } from '../models/EmployeeData';
import type { PolicyHistoryResponse } from '../models/PolicyHistoryResponse';
import type { PriceJobMode } from '../models/PriceJobMode';
import type { PricingPolicyType } from '../models/PricingPolicyType';
import type { SortDirection } from '../models/SortDirection';
import type { UpdateCompositePolicyAssignmentRequest } from '../models/UpdateCompositePolicyAssignmentRequest';
import type { UpdateCompositePolicyAssignmentResponse } from '../models/UpdateCompositePolicyAssignmentResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompositeService {

    /**
     * Get composites
     * @returns any Success
     * @throws ApiError
     */
    public static getComposites({
        requestBody,
    }: {
        requestBody: {
            plan?: Array<number>;
            paymarket?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            compositeIds?: Array<number>;
            isIndexed?: boolean;
            /**
             * Matches a composite with an explicit cut-selection CompositePricingPolicy row for one of these policy ids. Does not resolve to the company default.
             */
            cutSelectionPolicy?: Array<number>;
            /**
             * Matches a composite with an explicit weighting CompositePricingPolicy row for one of these policy ids. Does not resolve to the company default.
             */
            weightingPolicy?: Array<number>;
            /**
             * Matches composites whose resolved source (see CompositeSourcePolicy) is any of these. Precedence is manual, then exception, then companyDefault, same as sourcePolicy.
             */
            source?: Array<CompositePolicySource>;
            /**
             * Matches composites with a manual CompositePricingPolicy row made by one of these user ids. Exception rows and the company default have no author.
             */
            editedBy?: Array<number>;
            /**
             * Resolve the policies each composite prices with, where they came from and who hand-edited them, returned as sourcePolicy. Off by default: it costs up to three extra queries per request and only the Assign Policies page renders the answer.
             */
            includeSourcePolicy?: boolean;
            limit?: number;
            offset?: number;
            sort?: {
                companyJobTitle?: SortDirection;
                companyJobCode?: SortDirection;
                paymarketName?: SortDirection;
            };
        },
    }): CancelablePromise<{
        rows: Array<Composite>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get composites history
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositesHistory({
        limit,
        offset,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompositeHistory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/history',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Mass Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static addMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            paymarketId: number;
            surveyId: string;
            dataCutId: string;
            jobFamilyId?: Array<number>;
            jobSubFamilyId?: Array<number>;
            jobLevelId?: Array<number>;
            jobMode?: PriceJobMode;
            tagId?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<Array<{
        compositeId?: number;
        companyId?: number;
        planId?: number;
        paymarketId?: number;
        isIndexed?: number;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/mass',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Mass Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static deleteMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            paymarketId: number;
            surveyId: string;
            dataCutId: string;
            jobFamilyId?: Array<number>;
            jobSubFamilyId?: Array<number>;
            jobLevelId?: Array<number>;
            jobMode?: PriceJobMode;
            tagId?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/mass-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reset Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static resetMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            paymarketId?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export to excel
     * @returns any Success
     * @throws ApiError
     */
    public static exportToExcel({
        dataCutDisplayMode,
        composites,
        currencyPlanId,
    }: {
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
        /**
         * Composite ids
         */
        composites: Array<number>,
        /**
         * Currency plan to render amounts in. Omit to use each paymarket's own currency.
         */
        currencyPlanId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/export/summary',
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
                'composites': composites,
                'currencyPlanId': currencyPlanId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Pricing Policy
     * @returns any Success
     * @throws ApiError
     */
    public static updateCompositePricingPolicy({
        requestBody,
    }: {
        requestBody: {
            policyType: PricingPolicyType;
            policyId: number | null;
            plan?: Array<number>;
            paymarket?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            composite?: Array<number>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/pricingPolicy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update the composite-level adjustment
     * Sets the multiplicative adjustment applied to this composite's computed market amounts (`value * (1 + adjustment)`) after survey data cuts have been weighted, aged and rolled up. Send `null` to clear it. Not available for composites in an indexed paymarket — the value is propagated there from the base paymarket.
     * @returns Composite Success
     * @throws ApiError
     */
    public static updateCompositeAdjustment({
        compositeId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        requestBody: {
            adjustment: number | null;
        },
    }): CancelablePromise<Composite> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/composite/{compositeId}/adjustment',
            path: {
                'compositeId': compositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Override or reset the policies assigned to a set of composites
     * `override` pins the given policies to the selection as a manual assignment, which the exception apply step never overwrites. `resetToDefault` drops whatever is assigned and re-resolves the selection against the company's enabled exceptions; a composite that matches none of them keeps no row and prices off the company default.
     * @returns UpdateCompositePolicyAssignmentResponse Success
     * @throws ApiError
     */
    public static updateCompositePolicyAssignment({
        requestBody,
    }: {
        requestBody: UpdateCompositePolicyAssignmentRequest,
    }): CancelablePromise<UpdateCompositePolicyAssignmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/policyAssignment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List the users who made the company's current manual policy assignments
     * Options for the Assign Policies "Edited by" filter: every distinct author of a manual CompositePricingPolicy row, sorted by name. Hidden with a 404 while the policy_defaults flag is off.
     * @returns CompositePolicyEditor Success
     * @throws ApiError
     */
    public static getCompositePolicyAssignmentEditors({
        plan,
    }: {
        /**
         * Only authors of edits on composites in these plans — the plan the page shows. Without it, every plan counts.
         */
        plan?: Array<number>,
    }): CancelablePromise<Array<CompositePolicyEditor>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/policyAssignment/editors',
            query: {
                'plan': plan,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Data Cut List
     * @returns CompositeDataCut Success
     * @throws ApiError
     */
    public static getCompositeDataCutList({
        compositeId,
        sort,
        dataCutDisplayMode,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Sorting
         */
        sort?: {
            surveyName?: SortDirection;
            surveyVendorName?: SortDirection;
            weight?: SortDirection;
        },
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode?: DataCutDisplayMode,
    }): CancelablePromise<Array<CompositeDataCut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/datacut',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'sort': sort,
                'dataCutDisplayMode': dataCutDisplayMode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Data Cuts
     * @returns any Success
     * @throws ApiError
     */
    public static addCompositeDataCuts({
        compositeId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        requestBody: {
            surveyData: Array<{
                surveyDataId: string;
                surveyId: string;
                adjustment?: number;
                weight?: number;
            }>;
            removeUnusedJobMappings?: boolean;
            createLocalMappings?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/datacut',
            path: {
                'compositeId': compositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get adjustment and weight details
     * @returns CompositeDataCutAdjustmentDetails Success
     * @throws ApiError
     */
    public static getCompositeDataCutAdjustmentDetails({
        compositeId,
        surveyDataId,
    }: {
        compositeId: number,
        surveyDataId: string,
    }): CancelablePromise<CompositeDataCutAdjustmentDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/datacut/{surveyDataId}/adjustment',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static addCompositeDataCut({
        compositeId,
        surveyDataId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Survey Data Id
         */
        surveyDataId: string,
        requestBody?: {
            surveyId?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/datacut/{surveyDataId}',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompositeDataCut({
        compositeId,
        surveyDataId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Survey Data Id
         */
        surveyDataId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/composite/{compositeId}/datacut/{surveyDataId}',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Composite Data Cut
     * @returns CompositeDataCut Success
     * @throws ApiError
     */
    public static updateCompositeDataCut({
        compositeId,
        compositeDataCutId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Composite Data Cut Id
         */
        compositeDataCutId: number,
        requestBody: {
            adjustment: number;
            weight: number;
        },
    }): CancelablePromise<CompositeDataCut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/composite/{compositeId}/compositeDataCut/{compositeDataCutId}',
            path: {
                'compositeId': compositeId,
                'compositeDataCutId': compositeDataCutId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Comment List
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeCommentList({
        compositeId,
        limit,
        offset,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompositeComment>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/comment',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Comment
     * @returns CompositeComment Success
     * @throws ApiError
     */
    public static addCompositeComment({
        compositeId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<CompositeComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/comment',
            path: {
                'compositeId': compositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Composite Comment
     * @returns CompositeComment Success
     * @throws ApiError
     */
    public static updateCompositeComment({
        compositeId,
        commentId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Comment id
         */
        commentId: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<CompositeComment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/composite/{compositeId}/comment/{commentId}',
            path: {
                'compositeId': compositeId,
                'commentId': commentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Composite Comment
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompositeComment({
        compositeId,
        commentId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Comment id
         */
        commentId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/composite/{compositeId}/comment/{commentId}',
            path: {
                'compositeId': compositeId,
                'commentId': commentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get composite history
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeHistory({
        compositeId,
        limit,
        offset,
        year,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Year filter
         */
        year?: number,
    }): CancelablePromise<{
        rows: Array<CompositeHistory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/history',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'year': year,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List one page of the manual policy edits of one composite in a year
     * Override and Reset changes to the composite's cut selection and weighting policies, newest first. Changes made by applying policy defaults are company-wide events and are not listed here. Hidden with a 404 while the policy_defaults flag is off.
     * @returns PolicyHistoryResponse Success
     * @throws ApiError
     */
    public static getCompositePolicyHistory({
        compositeId,
        year,
        limit,
        offset,
    }: {
        compositeId: number,
        /**
         * Calendar year to list, the current one when omitted; the current year runs up to now.
         */
        year?: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<PolicyHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/policyHistory',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'year': year,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export composite to pdf
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompositeToPdf({
        compositeId,
        dataCutDisplayMode,
        currencyPlanId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
        /**
         * Currency plan to render amounts in. Omit to use each paymarket's own currency.
         */
        currencyPlanId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/pdf',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
                'currencyPlanId': currencyPlanId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export composite to xlsx
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompositeToXlsx({
        compositeId,
        dataCutDisplayMode,
        currencyPlanId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
        /**
         * Currency plan to render amounts in. Omit to use each paymarket's own currency.
         */
        currencyPlanId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/xlsx',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
                'currencyPlanId': currencyPlanId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Employee Data
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeEmployeeData({
        compositeId,
        limit,
        offset,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<EmployeeData>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/employee',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
